// extracted by mini-css-extract-plugin
export default {"container":"AspectRatioField_container__KMHSL","item":"AspectRatioField_item__WReIM","active":"AspectRatioField_active__Nadh2"};